import { PayloadAction } from "@reduxjs/toolkit";

import { DriversState } from '../../types';

export const setDeletingDriverFuelAssignmentStatus = (
  state: DriversState,
  action: PayloadAction<DriversState['fuelAssignment']['deletingStatus']>
) => {
  state.fuelAssignment.deletingStatus = action.payload;
};
